import { isLogin } from "@/utils/constant";
import axios from "axios";
import Cookies from "js-cookie";
const i18n_pop_run_test_ph = Cookies.get("i18n_pop_run_test_ph");
const cUserId = Cookies.get("cUserId");
console.log(process.env);
const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_API,
  withCredentials: true,
});
axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    const data = response.data;
    return data;
  },
  (err) => {
    if ((err + "").includes("701")) {
      !isLogin && goLogin();
    }
    return Promise.reject(err);
  }
);

const handleBackEndUrl = (url) => {
  if (!i18n_pop_run_test_ph || !isLogin) {
    return url;
  }
  return url + `?cUserId=${isLogin}`;
  return (
    url +
    "?i18n_pop_run_test_ph=" +
    encodeURIComponent(`${i18n_pop_run_test_ph}`) +
    `&userId=${isLogin}`
  );
};

const api = {
  // 获取用户头像
  getAvatar() {
    return (
      isLogin && axiosInstance.post(handleBackEndUrl("/open/api/avatar"), {})
    );
  },
  // 获取赛事信息
  raceGetUserRegistrationInfo() {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/auth/api/race/getUserRegistrationInfo"),
        {}
      )
    );
  },
  // 查询查询国家、城市赛事配置接口
  getUserRegistrationInfoHist() {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/auth/api/race/getUserRegistrationInfoHist"),
        {}
      )
    );
  },
  // 获取用户信息
  getUserInfo() {
    return (
      isLogin &&
      axiosInstance.post(handleBackEndUrl("/auth/api/race/getUserInfo"), {})
    );
  },
  // 报名信息提交接口
  saveRaceRegistrationInfo(param) {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/auth/api/race/saveRaceRegistrationInfo"),
        param
      )
    );
  },
  checkLogin(param) {
    return axiosInstance.post(
      handleBackEndUrl("/api/poprun/checkLogin"),
      param
    ); //报名
  },
  // 邀请码校验及校验是否可以提交参赛信息
  checkIsCanApply(param) {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/auth/api/race/checkIsCanApply"),
        param
      )
    ); //赛事，时间
  },
  // 上传图片接口
  uploadFile(data = {}) {
    return axiosInstance.post(
      handleBackEndUrl("/auth/api/base/upload/uploadFile"),
      data,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
  },
  getCountryCityList(param = {}) {
    return axiosInstance.post(
      handleBackEndUrl("/open/api/base/getCountryCityList"),
      param
    ); //国家城市
  },
  // 断点登录
  login(followup) {
    return axios.get(handleBackEndUrl(`/open/api/login?followup=${followup} `));
  },
  // 查询对应国家城市赛事报名人数情况
  getRaceRemainingQutota(data = {}) {
    return axiosInstance.post(
      handleBackEndUrl("/api/race/getRaceRemainingQutota"),
      data
    );
  },
  getRaceConfigInfo(param = {}) {
    return axiosInstance.post(
      handleBackEndUrl("/open/api/race/getRaceConfigInfo"),
      param
    ); //赛事，时间
  },
  upload(language, param) {
    return axiosInstance.postform(
      handleBackEndUrl("/api/poprun/" + language + "/upload"),
      param
    ); //上传
  },
  getUserRegistrationInfo() {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/api/race/getUserRegistrationInfo"),
        {}
      )
    ); //报名
  },
  // 管理员需二次审核人数查询
  countConfirmParticipants() {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/auth/api/race/countConfirmParticipants"),
        {}
      )
    ); //报名
  },
  // 获取广告位
  queryDictInfo(dictCode = "default") {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/open/api/race/dict/queryDictInfo"),
        { itemCode: "ADVERTISEMENT_2024", dictCode }
      )
    ); //报名
  },
  // 获取广告位
  getRaceRegistrationFields(data) {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/auth/api/race/getRaceRegistrationFields"),
        data
      )
    ); //报名
  },
  querysSelectDictInfo() {
    return (
      isLogin &&
      axiosInstance.post(
        handleBackEndUrl("/open/api/race/dict/queryDictInfo"),
        { itemCode: "extended_field1_select", dictCode: "ph" }
      )
    ); //报名
  },
};
// 去登录
export const goLogin = () => {
  const followup = window.location.href;
  !isLogin &&
    (location.href = `${process.env.VUE_APP_BACKEND_API}/open/api/login?followup=${followup}`);
};
export { axiosInstance };
export default api;
